// =============================================================================
// src/data/analytics-insights-edition-query.ts — Queries GraphQL das edicoes
// diarias dos Cards Taticos (view serving.v_card_edition, migration 022 do
// AtalaIA; publicada pelo runner do host). DUAS queries de proposito: a LISTA
// roda na hidratacao do bootstrap SEM o corpo (~40KB/edicao fora do caminho
// critico); o BODY vem sob demanda por data, com `order_by generated_at desc,
// limit 1` (neutraliza linha duplicada, cinto extra alem da UNIQUE do banco).
// =============================================================================

import { ANALYTICS_GRAPHQL_ROOTS } from './analytics-graphql-roots';

/** Linha da LISTA de edicoes (sem markdown_body, de proposito). */
export interface AnalyticsCardEditionListRow {
  readonly edition_date: string;
  readonly doc_kind: string;
  readonly generated_at: string;
}

/** Linha do BODY de uma edicao especifica. */
export interface AnalyticsCardEditionBodyRow {
  readonly edition_date: string;
  readonly doc_kind: string;
  readonly markdown_body: string;
  readonly generated_at: string;
}

export interface AnalyticsCardEditionListGraphqlData {
  readonly editionRefs?: readonly AnalyticsCardEditionListRow[] | null;
}

export interface AnalyticsCardEditionBodyGraphqlData {
  readonly editionBodies?: readonly AnalyticsCardEditionBodyRow[] | null;
}

export const ANALYTICS_INSIGHT_EDITION_LIST_QUERY = `
  query AnalyticsInsightEditionList($clientId: uuid!) {
    editionRefs: ${ANALYTICS_GRAPHQL_ROOTS.cardEdition}(
      where: { client_id: { _eq: $clientId } }
      order_by: [{ edition_date: desc }, { generated_at: desc }]
    ) {
      edition_date
      doc_kind
      generated_at
    }
  }
`;

export const ANALYTICS_INSIGHT_EDITION_BODY_QUERY = `
  query AnalyticsInsightEditionBody($clientId: uuid!, $editionDate: date!) {
    editionBodies: ${ANALYTICS_GRAPHQL_ROOTS.cardEdition}(
      where: { client_id: { _eq: $clientId }, edition_date: { _eq: $editionDate } }
      order_by: { generated_at: desc }
      limit: 1
    ) {
      edition_date
      doc_kind
      markdown_body
      generated_at
    }
  }
`;
